// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.confirm-modal-content[data-v-3c94f312]{\n  width: 300px;\n  margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
